import React from 'react';
import { IconSvgProps } from '@models/common';

const TextBold: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4 8.00033H10C10.7072 8.00033 11.3855 8.28128 11.8856 8.78137C12.3857 9.28147 12.6667 9.95975 12.6667 10.667C12.6667 11.3742 12.3857 12.0525 11.8856 12.5526C11.3855 13.0527 10.7072 13.3337 10 13.3337H4.66667C4.48986 13.3337 4.32029 13.2634 4.19526 13.1384C4.07024 13.0134 4 12.8438 4 12.667V3.33366C4 3.15685 4.07024 2.98728 4.19526 2.86225C4.32029 2.73723 4.48986 2.66699 4.66667 2.66699H9.33333C10.0406 2.66699 10.7189 2.94794 11.219 3.44804C11.719 3.94814 12 4.62641 12 5.33366C12 6.0409 11.719 6.71918 11.219 7.21928C10.7189 7.71937 10.0406 8.00033 9.33333 8.00033'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TextBold;
